module.exports = __webpack_public_path__ + "static/media/AHW_05.fd97320a.jpg";